import React from "react";
import {
    Route,
    Routes,
    Navigate,
  } from "react-router-dom";
import { ColorModeContext, useMode } from "./theme.js";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Header from "./components/Header/index.jsx";
import Footer from "./components/Footer/index.jsx";
import Home from "./pages/home/index.jsx";
import Projects from "./pages/projects/index.jsx";
import About from "./pages/about/index.jsx";
import Contact from "./pages/contact/index.jsx";
import PrivacyPolicy from "./pages/privacypolicy/index.jsx";
import CookiePolicy from "./pages/cookiepolicy/index.jsx";
import Terms from "./pages/terms/index.jsx";

function App() {
    const [theme, colorMode] = useMode();

    return (
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className="app" style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}>
            {/* Header appears on every page */}
            <Header />
  
            {/* Main content will grow to fill available space */}
            <div style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route path="/cookiepolicy" element={<CookiePolicy />} />
                <Route path="/terms" element={<Terms />} />
                {/* Redirect unknown routes to Home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
  
            {/* Footer appears at the bottom */}
            <Footer />
          </div>
        </ThemeProvider>
      </ColorModeContext.Provider>
  );
  
}

export default App;